import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { HelperService } from '@app/core/services/helper.service';

@Component({
	selector: 'ui-checkbox-control',
	templateUrl: './checkbox-control.component.html',
	styleUrls: ['../../styles/form-controls.less', './checkbox-control.component.less'],
})
export class CheckboxControlComponent implements OnInit {
	@Input() form: FormGroup;
	@Input() form_control: FormControl;
	@Input() type: string = null;
	@Input() label: string;
	@Input() info: string = null;
	@Input() input_css_class: string = '';
	@Output() changed = new EventEmitter();
	@Output() cta = new EventEmitter();
	@Input() highlighted_info: boolean = false;

	form_control_id: string = '';
	form_control_name: string = '';
	label_parts: string[] = [];

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {HelperService} helper_service
	 */
	constructor(private helper_service: HelperService) {}

	/**
	 * Lifecycle hook: Sets control name and id. Also sets label parts array.
	 */
	ngOnInit(): void {
		let form_control_name = null;
		const parent = this.form_control.parent;

		if (parent instanceof FormGroup) {
			Object.keys(parent.controls).forEach((name) => {
				if (this.form_control === parent.controls[name]) {
					form_control_name = name;
				}
			});
		}

		this.form_control_name = form_control_name;
		this.form_control_id = 'checkbox_' + this.helper_service.generateRandomString(30);

		this.label_parts = this.label.split('|');
	}

	/**
	 * Checks if label part contains * to indicate CTA status.
	 *
	 * @param {string} label_part
	 * @returns {boolean}
	 */
	isCta(label_part: string): boolean {
		return label_part.indexOf('*') !== -1;
	}

	/**
	 * Gets CTA text from label part.
	 *
	 * @param {string} label_part
	 * @returns {string}
	 */
	getCtaText(label_part: string): string {
		return label_part.split('*')[0];
	}

	/**
	 * Checks if control fails validation.
	 *
	 * @returns {boolean}
	 */
	isInvalid(): boolean {
		return (this.form_control.dirty || this.form_control.touched) && this.form_control.invalid;
	}

	/**
	 * Checks if control passes validation.
	 *
	 * @returns {boolean}
	 */
	isValid(): boolean {
		return this.form_control.valid && this.form_control.value;
	}

	/**
	 * Handles when control is changed.
	 */
	onChange(): void {
		this.changed.emit(this.form_control.value);
	}

	/**
	 * Handles when CTA label part is triggered.
	 *
	 * @param e
	 * @param {string} label_part
	 */
	onCta(e, label_part: string): void {
		e.preventDefault();
		this.cta.emit(label_part.split('*')[1]);
	}
}
